module.exports = __webpack_public_path__ + "img/vida-logo-alt.21945165.png";